export default {
    container: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    player: {
        position: 'relative',
        width: '100%',
        height: '100%'
    }
};



// WEBPACK FOOTER //
// ./app/webapp/syndicated/ConnectedPlayer/style.js